export default __webpack_public_path__ + "static/media/tootipInfoIcon.4ead4cc9.svg";